<input numbersOnly
       [(ngModel)]="internalModel"
       [disabled]="ngReadonly"
       (ngModelChange)="modelChanged()"
       [decimals]="decimals"
       type="text"
       class="rd-numeric-field gridster-item-content">
